import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab66edaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-container flex-mid" }
const _hoisted_2 = { class: "center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-header" }, "Sign-in was not completed", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-body" }, [
  /*#__PURE__*/_createTextVNode(" Please close this page and try signing in again."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" If this keeps happening, contact support. ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-header" }, "Welcome to", -1))
const _hoisted_6 = { class: "text-header" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-body" }, "You're signed in. Taking you back now.", -1))
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hint" }, "If nothing happens, tap the button above.", -1))
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"text-body\" data-v-ab66edaa>Your account is set to login via SSO</div><div class=\"loading\" data-v-ab66edaa><div id=\"wrapper\" data-v-ab66edaa><div class=\"profile-main-loader\" data-v-ab66edaa><div class=\"loader\" data-v-ab66edaa><svg class=\"circular-loader\" viewBox=\"25 25 50 50\" data-v-ab66edaa><circle class=\"loader-path\" cx=\"50\" cy=\"50\" r=\"20\" fill=\"none\" stroke=\"#FFC75F\" stroke-width=\"6\" data-v-ab66edaa></circle></svg></div></div></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.viewState === 'error')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_3,
            _hoisted_4
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, " Happily" + _toDisplayString(_ctx.companyData.name ? " × " + _ctx.companyData.name : ""), 1),
            (_ctx.viewState === 'complete')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_7,
                  _createElementVNode("a", {
                    class: "action-button",
                    href: _ctx.redirectUri
                  }, "Continue to Happily", 8, _hoisted_8),
                  _hoisted_9
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_10
                ], 64))
          ], 64))
    ])
  ]))
}